import { render } from "./Administrador.vue?vue&type=template&id=8ff5c61a&scoped=true"
import script from "./Administrador.vue?vue&type=script&lang=js"
export * from "./Administrador.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./Administrador.vue?vue&type=style&index=1&id=8ff5c61a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ff5c61a"]])

export default __exports__